import * as React from 'react';
import { Card, Form, Row, Col, Collapse, Table, Button, Icon, Empty } from 'antd';
import { BolChargesResponseDto } from 'Core/Api/APMProxy/Api';
import { CargoChargesHandler } from '../CargoChargesForm/CargoChargesFormHandler';
import { IBolCharge } from 'Core/Api/Payment/Api';
import {
  StyleCargoChargesCollapse,
  StyleCargoChargesPanel,
  StyleCargoChargesResultContainer,
} from '../CargoCharges.Style';
import CargoChargesResultModel, { CargesModel } from './CargoChargesResultsModel';
import moment, { Moment } from 'moment';
import { CargoChargeItem } from '.';
import { RouteComponentProps, withRouter } from 'react-router-dom';

export interface Props {
  children?: React.ReactNode;
  results: Array<CargoChargesResultModel>;
  updatePickupDate: (string, Moment) => void;
  removeShipment: (cargo: CargoChargesResultModel) => void;
}

export interface State {
  data: Array<CargoChargesResultModel>;
}

export default class CargoChargesResults extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    return (
      <>
        {!this.props.results || this.props.results!.length <= 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
            <StyleCargoChargesResultContainer span={24}>
              {this.props.results.slice(0).reverse().map((cargoCharge, key) => (
                <CargoChargeItem
                  cargoCharge={cargoCharge}
                  updatePickupDate={this.props.updatePickupDate}
                  removeShipment={this.props.removeShipment}
                />
              ))}
            </StyleCargoChargesResultContainer>
          )}
      </>
    );
  }
}
